export const REFETCH_INTERVAL = 1000 * 60 * 5
